import React from 'react';
import { EmailSummary } from './fields/OTP/EmailSummary';
import { OTP } from './fields/OTP/OTP';
import MessageBox from 'components/commons/MessageBox/MessageBox';
import { SnackBar } from 'componentsV2/SnackBar/SnackBar';
import { MESSAGEBOX_TYPE } from './fields/OTP/constants';

export const OTPEmailSummary = ({
    dispatch,
    email,
    errorMessage,
    handleClickModifyEmail,
    isOTPValidated,
    messageBox,
    preLoaderActions,
    readyCaptchaToken,
    retryOTPCounter,
    sendEmailOTP,
    snackBar,
    validateOTP,
}) => {
    return (
        <div className="otp">
            <EmailSummary email={email} handleClickModifyEmail={handleClickModifyEmail} />
            <div className="otp__section">
                <OTP
                    dispatch={dispatch}
                    errorMessage={errorMessage}
                    isOTPValidated={isOTPValidated}
                    preLoaderActions={preLoaderActions}
                    readyCaptchaToken={readyCaptchaToken}
                    retryOTPCounter={retryOTPCounter}
                    sendEmailOTP={sendEmailOTP}
                    validateOTP={validateOTP}
                />
                <div className="otp__section__message">
                    {messageBox.type === MESSAGEBOX_TYPE.ERROR && (
                        <MessageBox contentText={messageBox.text} boxColor="red" iconColor="alert-red" />
                    )}
                    {messageBox.type === MESSAGEBOX_TYPE.WARNING && (
                        <MessageBox contentText={messageBox.text} boxColor="yellow" iconColor="warning-yellow" />
                    )}
                </div>
            </div>
            {snackBar.type && <SnackBar type={snackBar.type} text={snackBar.text} />}
        </div>
    );
};
